import ImageUpload from 'components/CustomUpload/ImageUpload'
import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'reactstrap'
import ProductContext from 'context/product/productContext'
import { initialData } from './ImagesUpload'

const ImagesUploadReview = ({ item, isDisabled }) => {
  const productContext = useContext(ProductContext)

  const { loadProductImages } = productContext

  const [currentImages, setCurrentImages] = useState(initialData)

  useEffect(() => {
    console.log('item is: ' + JSON.stringify(item))
    if (item.images == null) {
      loadProductImages(item.pkProduct).then(images => {
        if (images.length > 0) {
          setCurrentImages(images)
          item.images = images
        }
      })
    } else {
      setCurrentImages(item.images)
    }
    console.log('currentImages is: ' + JSON.stringify(currentImages))
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.pkProduct, item?.images])

  const updateImageInfo = (imageIndex, imageData) => {
    console.log('in updateImageInfo')
    console.log('imageIndex is: ' + imageIndex)
    console.log('imageData is: ' + JSON.stringify(imageData))
    let newImages = [...currentImages]
    newImages[imageIndex] = {
      ...newImages[imageIndex],
      ImageName: imageData.ImageName,
      ImageType: imageData.ImageType,
      ProdImg: imageData.ProdImg,
    }
    item.images = newImages
    setCurrentImages(newImages)
  }

  return (
    <Row>
      {currentImages.map((imageData, index) => {
        return (
          <Col xs={3} className="text-center" key={index}>
            <ImageUpload
              index={index}
              imageInfo={imageData}
              updateImageInfo={updateImageInfo}
              isSubmitter={false}
              isDisabled={isDisabled}
            />
          </Col>
        )
      })}
    </Row>
  )
}

ImagesUploadReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default ImagesUploadReview
